import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ROUTES as AUTH_ROUTES } from '../modules/Auth';
import { ROUTES as ADMIN_DASHBOARD_ROUTES } from './modules/AdminDashboard';
import { ROUTES as BILLING_ROUTES } from './modules/Billing';
import { ROUTES as COMPANIES_ROUTES } from './modules/Companies';
import { ROUTES as FEATURE_FLAGS_ROUTES } from './modules/FeatureFlags';
import AdminPanelApp from './AdminPanelApp';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';

export const getAdminPanelRoutes = () => {
    const routes = createBrowserRouter([
        ...AUTH_ROUTES,
        {
            path: '/',
            element: <AdminPanelApp />,
            errorElement: <ErrorBoundary />,
            children: [
                ...ADMIN_DASHBOARD_ROUTES,
                ...FEATURE_FLAGS_ROUTES,
                ...COMPANIES_ROUTES,
                ...BILLING_ROUTES,
                {
                    path: '/',
                    element: <Navigate replace to="/dashboard" />
                },
                {
                    path: '*',
                    element: <Navigate replace to="/dashboard" />
                }
            ]
        }
    ]);

    return routes;
};
